// RN 0.84's @react-native/babel-preset no longer provides a global
// `regeneratorRuntime`; pre-transpiled deps (e.g. dva-core) still reference it.
// The web bundle (rspack) has its own entry, so polyfill it here too — keep first.
import 'regenerator-runtime/runtime'
import React from 'react'
import { AppRegistry } from 'react-native'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { name as appName } from '../app.json'
import App from '../src/App'
import './main.css'

const googleWebClientId = process.env.GOOGLE_WEB_CLIENT_ID

if (!googleWebClientId) {
  throw new Error(
    'Missing GOOGLE_WEB_CLIENT_ID. Set the Google web client ID before loading the web app.',
  )
}

AppRegistry.registerComponent(appName, () => () => (
  <GoogleOAuthProvider clientId={googleWebClientId}>
    <App />
  </GoogleOAuthProvider>
))

AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: global.document.getElementById('app-root'),
})
